import { CLICK_PRIMARY_CARE_CHECKBOX } from './ConfirmPrimaryCareActions';
import { APPOINTMENT_REQUIREMENTS_STRINGS } from '../../constants';
import * as AppointmentRequirementActions from '../../AppointmentRequirementsActions';

const InitialState = { value: false };

export default function confirmPrimaryCareReducer(
    state = InitialState,
    action
) {
    const { type, payload } = action;

    switch (type) {
        case CLICK_PRIMARY_CARE_CHECKBOX:
            return {
                ...state,
                value: payload.primaryCareConfirmation,
                error: undefined,
            };
        case AppointmentRequirementActions.SHOW_VALIDATION_ERRORS: {
            return {
                ...state,
                error: !state.value
                    ? APPOINTMENT_REQUIREMENTS_STRINGS.MustConfirmPcp
                    : undefined,
            };
        }
        default:
            return state;
    }
}
